import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=9fe80ed0&scoped=true&"
import script from "./dataAnalysis.vue?vue&type=script&lang=js&"
export * from "./dataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=9fe80ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe80ed0",
  null
  
)

component.options.__file = "dataAnalysis.vue"
export default component.exports